import { identity, pickBy } from 'lodash/fp';
import { http } from '../common/utils';
import { CLASSTING_API_URL } from '../common/constants';

export const fetchClazGroup = ({ gid }) => http.get(`${CLASSTING_API_URL}/v1/class_groups/${gid}`);

// TODO: 전체 클래스 그룹 갯수 확인 후 순차적으로 불러오도록 변경
export const fetchClazzGroups = ({ sid, perPage = 100 }) => http.get(`${CLASSTING_API_URL}/v1/schools/${sid}/class_groups`, {
  params: { per_page: perPage },
});

export const createClazzGroup = ({ sid, grade, clazzName }) => http.post(
  `${CLASSTING_API_URL}/v1/schools/${sid}/class_groups`,
  { class_group: { grade, class_name: clazzName } },
);

export const updateClazzGroup = ({ gid, grade, clazzName }) => http.put(
  `${CLASSTING_API_URL}/v1/class_groups/${gid}`,
  pickBy(identity, { class_group: { grade, class_name: clazzName } }),
);

export const deleteClazzGroup = ({ gid }) => http.delete(`${CLASSTING_API_URL}/v1/class_groups/${gid}`);

export const fetchCustomGroup = ({ gid }) => http.get(`${CLASSTING_API_URL}/v1/custom_groups/${gid}`);

export const fetchCustomGroups = ({ sid, perPage }) => http.get(`${CLASSTING_API_URL}/v1/schools/${sid}/custom_groups`, {
  params: { per_page: perPage },
});

export const createCustomGroup = ({ sid, name }) => http.post(
  `${CLASSTING_API_URL}/v1/schools/${sid}/custom_groups`,
  { custom_group: { name } },
);

export const updateCustomGroup = ({ gid, name }) => http.put(
  `${CLASSTING_API_URL}/v1/custom_groups/${gid}`,
  { custom_group: { name } },
);

export const deleteCustomGroup = ({ gid }) => http.delete(`${CLASSTING_API_URL}/v1/custom_groups/${gid}`);

export const fetchContactsBySchool = ({
  sid, grade, pageNumber = 1, perPage = 10, query, sort = '-created_at',
}) => http.get(`${CLASSTING_API_URL}/v1/schools/${sid}/contacts`, {
  params: pickBy(identity, {
    grade,
    sort,
    page: pageNumber,
    per_page: perPage,
    q: query,
  }),
});

export const fetchContactsByClazzGroup = ({
  gid, grade, pageNumber = 1, perPage = 10, query, sort = '-created_at',
}) => http.get(`${CLASSTING_API_URL}/v1/class_groups/${gid}/contacts`, {
  params: pickBy(identity, {
    grade,
    sort,
    page: pageNumber,
    per_page: perPage,
    q: query,
  }),
});

export const fetchContactsCount = ({ sid }) => http.get(`${CLASSTING_API_URL}/v1/schools/${sid}/school_count`);

export const fetchContactsByCustomGroup = ({
  gid, grade, pageNumber = 1, perPage = 10, query, sort = '-created_at',
}) => http.get(`${CLASSTING_API_URL}/v1/custom_groups/${gid}/contacts`, {
  params: pickBy(identity, {
    grade,
    sort,
    page: pageNumber,
    per_page: perPage,
    q: query,
  }),
});

export const fetchContact = ({ cid }) => http.get(`${CLASSTING_API_URL}/v1/contacts/${cid}`);

export const updateContact = ({
  cid, grade, clazzName, name, clazzNumber, phoneNumber, email, clazzGroup, customGroups,
}) => http.put(
  `${CLASSTING_API_URL}/v1/contacts/${cid}`,
  {
    grade,
    name,
    email,
    class_name: clazzName,
    number: clazzNumber,
    mobile: phoneNumber,
    class_group_id: clazzGroup,
    custom_group_ids: customGroups,
  },
);

export const deleteContact = ({ cid }) => http.delete(`${CLASSTING_API_URL}/v1/contacts/${cid}`);

export const deleteContacts = ({ sid }) => http.delete(`${CLASSTING_API_URL}/v1/schools/${sid}/contacts`);

export const fetchGuardianContact = ({ gcid }) => http.get(`${CLASSTING_API_URL}/v1/guardian_contacts/${gcid}`);

export const updateGuardianContact = ({
  gcid, name, email, relationship, phoneNumber, level,
}) => http.put(`${CLASSTING_API_URL}/v1/guardian_contacts/${gcid}`, {
  name,
  email,
  relationship,
  level,
  mobile: phoneNumber,
});

export const deleteGuardianContact = ({ gcid }) => http.delete(`${CLASSTING_API_URL}/v1/guardian_contacts/${gcid}`);

export const fetchGuardianContactsByContact = ({ cid }) => http.get(`${CLASSTING_API_URL}/v1/contacts/${cid}/guardian_contacts`);

export const createGroupRelationship = ({ cid, gid }) => http.post(`${CLASSTING_API_URL}/v1/group_relationships`, {
  group_relationship: {
    contact_id: cid,
    custom_group_id: gid,
  },
});

export const deleteGroupRelationship = ({ cid, gid }) => http.delete(`${CLASSTING_API_URL}/v1/group_relationships`, {
  data: {
    contact_id: cid,
    custom_group_id: gid,
  },
});
